/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useForkRef = _interopRequireDefault(require("@mui/utils/useForkRef"));
var _default = exports.default = _useForkRef.default;
